import { composeIO } from 'react-compose-io'
import { formAssociacaoIO } from './FormAssociacao.IO'
import { FormAssociacaoView } from './FormAssociacao.View'

export const FormAssociacao = composeIO(FormAssociacaoView, formAssociacaoIO)
